/**
 * Single source of truth for the redirect sign-in sessionStorage keys.
 * `auth-modular` imports these rather than redeclaring them, so the two
 * modules cannot drift apart.
 */
export const REDIRECT_PENDING_KEY = "firebase_redirect_pending";
export const REDIRECT_UID_KEY = "firebase_redirect_uid";

export const hasPendingAuthRedirectFlag = (): boolean => {
  try {
    return sessionStorage.getItem(REDIRECT_PENDING_KEY) === "1";
  } catch {
    return false;
  }
};

export const clearRedirectResultFlag = (): void => {
  try {
    sessionStorage.removeItem(REDIRECT_PENDING_KEY);
    sessionStorage.removeItem(REDIRECT_UID_KEY);
  } catch {
    // ignore
  }
};

export const hasRedirectResultFlag = (): boolean => {
  try {
    return !!sessionStorage.getItem(REDIRECT_UID_KEY);
  } catch {
    return false;
  }
};
